var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetpdf = function SvgAssetpdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F24822",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.335 15.167v-2.733c0-.954 0-1.43-.178-1.86-.177-.428-.514-.766-1.19-1.44l-5.525-5.526c-.582-.582-.873-.873-1.234-1.045a2 2 0 0 0-.23-.096c-.377-.133-.789-.133-1.611-.133-3.786 0-5.68 0-6.962 1.034a4.7 4.7 0 0 0-.703.703c-1.034 1.285-1.034 3.176-1.034 6.962v4.134m10.5-12.25v.584c0 3.299 0 4.95 1.026 5.974 1.024 1.026 2.675 1.026 5.974 1.026h.583m.292 8.166h-2.917a1.167 1.167 0 0 0-1.166 1.167v2.333m0 0v3.5m0-3.5h3.5m-17.5 3.5v-2.916m0 0v-4.084H7a2.042 2.042 0 1 1 0 4.084zm7-4.084h1.75a2.334 2.334 0 0 1 2.333 2.334v2.333a2.334 2.334 0 0 1-2.333 2.333h-1.75z"
  })));
};
export default SvgAssetpdf;